import React from 'react'
import truck from '../../assets/bgtruck.svg'
import logo from "../../assets/Logo.svg"
import fb from '../../assets/fb.svg'
import twitter from '../../assets/twitter.svg'
import linkedin from '../../assets/linkedin.svg'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
const Herosection = () => {
        const navigate = useNavigate();
      const authToken = localStorage.getItem("accessToken");

    return (
        <>
            <div
                className="relative min-h-screen  bg-cover bg-center flex flex-col items-center text-white"
                style={{ backgroundImage: `url(${truck})` }}
            >
                {/* Top Navbar */}
                <div className="w-full flex flex-col sm:flex-row justify-between items-center px-4 sm:px-6 py-4">
                    {/* Social Icons */}
                    <div className="flex gap-3 sm:gap-4 text-white text-lg sm:text-xl mb-4 sm:mb-0">
                        <img src={twitter} className="cursor-pointer w-6 h-6 sm:w-auto sm:h-auto" />
                        <img src={fb} className="cursor-pointer w-6 h-6 sm:w-auto sm:h-auto" />
                        <img src={linkedin} className="cursor-pointer w-6 h-6 sm:w-auto sm:h-auto" />
                    </div>

                    {/* Logo */}
                    <Link to='/' className="text-white font-bold text-xl sm:text-2xl tracking-wider">
                        <img src={logo} alt="Logo" className="w-[150px] sm:w-[213px] h-auto mx-auto" />
                    </Link>

                    {/* Buttons */}
                      <div className="flex gap-3 sm:gap-4 mt-4 sm:mt-0">
            <button
              onClick={() => navigate(authToken ? "/dashboard/home" : "/login")}
              className="bg-purple-600 hover:bg-purple-700 text-white text-sm sm:text-base px-3 sm:px-4 py-2 rounded-full w-[80px] sm:w-[100px] font-semibold"
            >
              {authToken ? "Dashboard" : "Log In"}
            </button>
            {!authToken && (
              <button
                onClick={() => navigate("/signup")}
                className="bg-purple-600 hover:bg-purple-700 text-white text-sm sm:text-base px-3 sm:px-4 py-2 w-[80px] sm:w-[100px] rounded-full font-semibold"
              >
                Sign Up
              </button>
            )}
          </div>
                </div>

                {/* Main Content */}
                <div className=" mt-36 text-center self-center  ml-4 sm:ml-7 w-full sm:w-auto">
                    <h1 className="text-[40px] sm:text-[60px] font-inter font-bold leading-[1.1] mb-4">
                        Contact Us

                    </h1>
                 <p className="mb-6 text-[18px] sm:text-[25px] text-gray-300 leading-[1.2] px-4 sm:px-0">
  Smart Dispatch Software and Driver App built for fast-growing logistics companies in the USA 
  <br className="hidden sm:block" /> 
  and Latin America.
</p>


                </div>

            </div>
        </>
    )
}

export default Herosection